import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { IconButton, TableContainer, Grid, Box } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { enUS, frFR } from '@mui/material/locale';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
const PaymentGatewaysEnum = require('../../common/payment-gateways').default;


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "firstname", numeric: false, disablePadding: false, label: t("Report.iPay.FirstName"), padding: '10px', field: 'first_name' },
      { id: "lastname", numeric: false, disablePadding: false, label: t("Report.iPay.LastName"), padding: '10px', field: 'last_name' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.iPay.Store"), padding: '10px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.iPay.Location"), padding: '10px', field: 'name' },
      { id: "pucode", numeric: false, disablePadding: false, label: t("Report.iPay.PUCode"), padding: '10px', field: 'pucode' },
      { id: "transaction_id", numeric: false, disablePadding: false, label: t("Report.iPay.TransactionID"), padding: '10px', field: 'sales_id' },
      { id: "trans_status", numeric: false, disablePadding: false, label: t("Report.iPay.TransactionStatus"), padding: '10px', field: 'trans_status' },
      { id: "masked_card_number", numeric: false, disablePadding: false, label: t("Report.iPay.CardNumber"), padding: '10px', field: 'masked_card_number' },
      { id: "card_type", numeric: false, disablePadding: false, label: t("Report.iPay.CardType"), padding: '10px', field: 'card_type' },
      { id: "card_brand", numeric: false, disablePadding: false, label: t("Report.iPay.CardBrand"), padding: '10px', field: 'card_brand' },
      { id: "entry_type", numeric: false, disablePadding: false, label: t("Report.iPay.EntryType"), padding: '10px', field: 'entry_type' },
      { id: "reference_id", numeric: false, disablePadding: false, label: t("Report.iPay.ReferenceID"), padding: '10px', field: 'reference_id' },
      { id: "payment_date", numeric: false, disablePadding: false, label: t("Report.iPay.PaymentDateTime"), padding: '10px', field: 'payment_date' },
      { id: "payment_type", numeric: false, disablePadding: false, label: t("Report.iPay.PaymentType"), padding: '10px', field: 'payment_type' },
      { id: "currency_code", numeric: false, disablePadding: false, label: t("Report.iPay.CurrencyCode"), padding: '10px', field: 'currency_code' },
      { id: "approved_amt", numeric: false, disablePadding: false, label: t("Report.iPay.TotalAmount"), padding: '10px', field: 'approved_amt' },
      { id: "type", numeric: false, disablePadding: false, label: t("Report.iPay.Type"), padding: '10px', field: 'type' }
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
              >
                {[
                  "transaction_id",
                  "masked_card_number",
                  "reference_id",
                  "currency_code",
                  "approved_amt",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);


const styles = theme => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '10px'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'payment_date',
  tableName: '',
  group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "payment_date",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      selectedObject: null,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      SelectedPaymentGateway: '',
      confirmationForRefund: false,
      reversalConfirmationMessage: '',
      isSendingRequest: false,
      isHidden: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      queryId: "",
      groups: [],
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        let All = [{ id: "-1", name: this.props.t('All') }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
    this.fetchSuggestions();
    this.BindGrid();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/iPayTransactionReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['StoreID', 'FirstName', 'LastName', 'Store', 'Box', 'PickUpCode', 'TransactionID', 'TransationStatus', 'CardNumber', 'CardType', 'CardBrand', 'EntryType', 'ReferenceID', 'PaymentDate/Time', 'PaymentType', 'CurrencyCode', 'TotalAmount', 'Type']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.firstname,
                  i.lastname,
                  i.store,
                  i.box,
                  i.pucode,
                  i.transaction_id,
                  i.trans_status,
                  i.masked_card_number,
                  i.card_type,
                  i.card_brand,
                  i.entry_type,
                  i.reference_id,
                  i.payment_date ? this.convertToTimeZone(i && i.payment_date) : '',
                  (i && i.selected_payment_gateway === PaymentGatewaysEnum.AXIAMED && i.type === "hpp") ? "" : (i.payment_type || i.card_type),
                  i.currency_code,
                  i.approved_amt ? '$' + parseFloat(i.approved_amt).toFixed(2) : '$0.00',
                  i.type
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "iPayTransactionReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      })
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['firstname', 'lastname'].includes(field)) {
      tablename = 'customers';
    }
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts';
    }
    if (['pucode'].includes(field)) {
      tablename = 'prescriptions_master';
    }
    if (['trans_status', 'card_type', 'card_brand', 'entry_type', 'payment_date', 'payment_type'].includes(field)) {
      tablename = 'payments';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    TransactionFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    const { data } = this.state;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          let All = [{ id: "-1", name: this.props.t('All') }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });


    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.accountValues.length; i++) {
        const element = storeid.findIndex(x => x.id === this.state.accountValues[i].id);
        if (element > -1) {
        }
        else {
          chipprocessed.push(this.state.accountValues[i]);
          processed.push(this.state.accountValues[i]);
        }
      }
    }
    else if (storeid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
        else {

        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        const element = boxid.findIndex(x => x.id === this.state.boxvalues[i].id);
        if (element > -1) {
        }
        else {
          chipprocessed.push(this.state.boxvalues[i]);
          processed.push(this.state.boxvalues[i]);
        }
      }
    }
    else if (boxid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
        else {

        }
      }
    }
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }


    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };
  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    date = date ? moment(date).format() : '';
    this.setState({ fromdate: date });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
    this.BindGrid();
  };
  onToDateSelect = date => {
    date = date ? moment(date).format() : '';
    this.setState({ todate: date });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
    this.BindGrid();
  };


  handleBlurfrom = (value, date) => {
    this.setState({
      fromdate: null
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
    this.BindGrid();
  }
  handleBlurtodate = (value, date) => {
    this.setState({
      todate: null
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
    this.BindGrid();
  }

  BindGrid() {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'getiPayTransaction', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({ data: uData && uData.results, totalRecords: uData && uData.total });
          setTimeout(() => {
            this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isButtonDisabled: false })
          }, 5000)
        }
        else {
          this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true });
        }
      });
  }
  handlePUcodeClick = (event, transaction_id) => {
    event.preventDefault();
    const selectedObject = this.state.data.find(x => (x.transaction_id || x.trans_id) === transaction_id);
    const ReceiptObj = selectedObject && JSON.parse(selectedObject.receipt);
    let paymentDetail;
    if (selectedObject.selected_payment_gateway === PaymentGatewaysEnum.GLOBAL_PAYMENTS) {
      if (ReceiptObj !== null && ReceiptObj !== 'null' && ReceiptObj !== '') {
        const paymentDetailsobj = ReceiptObj && ReceiptObj.labeled_attributes;
        let payamount = paymentDetailsobj && paymentDetailsobj.total_amount && paymentDetailsobj.total_amount.value;
        let totalpaidamount = payamount && payamount.replace("USD", "");
        paymentDetail = {
          username: `${selectedObject && selectedObject.firstname.trim().charAt(0)}. ${selectedObject && selectedObject.lastname.substring(0, 3)}.`,
          ReceiptNumber: ReceiptObj && ReceiptObj.id,
          Batch: paymentDetailsobj && paymentDetailsobj.batch_number && paymentDetailsobj.batch_number.value,
          TransID: paymentDetailsobj && paymentDetailsobj.transaction_id && paymentDetailsobj.transaction_id.value,
          OrderID: paymentDetailsobj && paymentDetailsobj.reference_id && paymentDetailsobj.reference_id.value,
          TransType: paymentDetailsobj && paymentDetailsobj.transaction_type && paymentDetailsobj.transaction_type.value,
          Date_Time: paymentDetailsobj && paymentDetailsobj.transaction_datetime && paymentDetailsobj.transaction_datetime.value,
          CardType: paymentDetailsobj && paymentDetailsobj.card_type && paymentDetailsobj.card_type.value,
          CardNumber: paymentDetailsobj && paymentDetailsobj.masked_card_number && paymentDetailsobj.masked_card_number.value,
          EntryMethod: paymentDetailsobj && paymentDetailsobj.entry_method && paymentDetailsobj.entry_method.value,
          ApprovalCode: paymentDetailsobj && paymentDetailsobj.approval_code && paymentDetailsobj.approval_code.value,
          TotalAmount: totalpaidamount,
          order_id: selectedObject && selectedObject.order_id,
          customer_id: selectedObject && selectedObject.customer_id
        }
      } else {
        paymentDetail = {
          username: `${selectedObject && selectedObject.firstname.trim().charAt(0)}. ${selectedObject && selectedObject.lastname.substring(0, 3)}.`,
          ReceiptNumber: '',
          Batch: selectedObject && selectedObject.batch_no,
          TransID: selectedObject && (selectedObject.transaction_id || selectedObject.trans_id),
          OrderID: selectedObject && selectedObject.reference_id,
          TransType: '',
          Date_Time: selectedObject && selectedObject.payment_date ? this.convertToTimeZone(selectedObject.payment_date) : '',
          CardType: selectedObject && selectedObject.card_type,
          CardNumber: selectedObject && (selectedObject.masked_card_number || selectedObject.account_no),
          EntryMethod: selectedObject && selectedObject.entry_type,
          ApprovalCode: selectedObject && selectedObject.approved_code,
          TotalAmount: selectedObject && selectedObject.approved_amt ? '$' + parseFloat(selectedObject.approved_amt).toFixed(2) : '$0.00',
          order_id: selectedObject && selectedObject.order_id,
          customer_id: selectedObject && selectedObject.customer_id
        }
      }
      this.setState({ detailDialogOpen: true, selectedObject: paymentDetail, SelectedPaymentGateway: selectedObject.selected_payment_gateway });
    } else {
      paymentDetail = {
        username: `${selectedObject && selectedObject.firstname.trim().charAt(0)}. ${selectedObject && selectedObject.lastname.substring(0, 3)}.`,
        trans_id: (selectedObject && selectedObject.trans_id) || (selectedObject && selectedObject.transaction_id),
        trans_status: selectedObject && selectedObject.trans_status,
        reference_id: selectedObject && selectedObject.reference_id,
        type: selectedObject && selectedObject.type,
        remote_id: selectedObject && selectedObject.remote_id,
        payment_date: selectedObject && selectedObject.payment_date ? this.convertToTimeZone(selectedObject.payment_date) : '',
        card_holder: (selectedObject && selectedObject.card_holder) || "",
        card_type: selectedObject && selectedObject.card_type,
        masked_card_number: selectedObject && selectedObject.masked_card_number,
        card_expiration_date: `${selectedObject && selectedObject.exp_month}/${selectedObject && selectedObject.exp_year}`,
        input_method: selectedObject && selectedObject.entry_type,
        amount: selectedObject && selectedObject.approved_amt ? '$' + parseFloat(selectedObject.approved_amt).toFixed(2) : '$0.00',
        selected_payment_gateway: selectedObject && selectedObject.selected_payment_gateway,
        box_id: selectedObject && selectedObject.boxid,
        order_id: selectedObject && selectedObject.order_id,
        customer_id: selectedObject && selectedObject.customer_id
      }
      this.setState({ detailDialogOpen: true, selectedObject: paymentDetail, SelectedPaymentGateway: selectedObject.selected_payment_gateway });
    }
  }
  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: null })
  }
  PrintDetails = () => {
    setTimeout(() => {
      window.print();
      this.setState({ detailDialogOpen: false, selectedObject: null })
    }, 1000);
  }

  returnReceiptDetails = (selectedObject, classes) => {
    const { t } = this.props;
    let { SelectedPaymentGateway } = this.state;
    if ((SelectedPaymentGateway === null ||
      SelectedPaymentGateway === 'null' ||
      SelectedPaymentGateway === undefined ||
      SelectedPaymentGateway === 'undefined' ||
      SelectedPaymentGateway === '')) {
      SelectedPaymentGateway = PaymentGatewaysEnum.GLOBAL_PAYMENTS
    }
    switch (SelectedPaymentGateway) {
      case PaymentGatewaysEnum.GLOBAL_PAYMENTS: return (<TableBody>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.BatchHash")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.Batch}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.TransID}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ReceiptNumber")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.ReceiptNumber}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionType")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.TransType}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.DateTime")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.Date_Time}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardType")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.CardType}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardNumber")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.CardNumber}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.EntryMethod")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.EntryMethod}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ApprovalCode")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.ApprovalCode}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TotalAmount")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.TotalAmount}</TableCell>
        </TableRow>
      </TableBody>);
      case PaymentGatewaysEnum.AXIAMED: return (<TableBody>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.trans_id}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionStatus")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.trans_status}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ReferenceID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.reference_id}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TypeHPP")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.type}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.RemoteID")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.remote_id}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.DateTime")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.payment_date}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardHolderName")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.card_holder}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardType")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.card_type}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardNumber")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.masked_card_number}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ExpirationDate")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.card_expiration_date}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.EntryMethod")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.input_method}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TotalAmount")}</TableCell>
          <TableCell className={classes.padding10px}>{selectedObject && selectedObject.amount}</TableCell>
        </TableRow>
      </TableBody>);
      default: return (<TableBody>
        <TableRow>
          <TableCell colSpan={5}>{t("Report.iPay.NoDataFound")}</TableCell>
        </TableRow>
      </TableBody>);
    }
  }

  handleConfirmRefundOpenOrClose = (e) => {
    this.setState({
      confirmationForRefund: !this.state.confirmationForRefund,
      reversalConfirmationMessage: 'Are you sure you want to refund order amount?',
      isHidden: false,
      isButtonDisabled: false,
      detailDialogOpen: false
    });
  }

  initRefund = () => {
    const { selectedObject } = this.state;
    console.log(selectedObject);
    const payLoad = {
      boxId: selectedObject && selectedObject.box_id,
      reference_id: selectedObject && selectedObject.reference_id,
    }
    this.setState({ isButtonDisabled: true });
    fetch(process.env.REACT_APP_BASEURL + "axia-med/transaction/reversal", {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payLoad)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(async (reversalResponseObject) => {
      console.log(reversalResponseObject && reversalResponseObject.data)
      if (reversalResponseObject && reversalResponseObject.data && reversalResponseObject.data.statusCode === 500) {
        this.setState({
          reversalConfirmationMessage: 'Payment has already been refunded to your account!',
          isHidden: true,
          isButtonDisabled: false
        });
      } else if (reversalResponseObject && reversalResponseObject.data && reversalResponseObject.data.statusCode === 200) {
        await this.syncAxiaMedsRefundWithCloud(reversalResponseObject.data, (selectedObject && selectedObject.order_id), (selectedObject && selectedObject.customer_id));
      }
    });
  }

  syncAxiaMedsRefundWithCloud = async (data, order_id, customer_id) => {
    let object = this.prepareReversalObject(data, order_id, customer_id);
    fetch(process.env.REACT_APP_BASEURL + "axia-med/hpps/sync/reversal/entries", {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(object)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(reversalSyncResponseObject => {
      if (reversalSyncResponseObject && reversalSyncResponseObject.sent === true) {
        this.setState({
          reversalConfirmationMessage: 'Payment has been refunded successfully!',
          isHidden: true,
          isButtonDisabled: false
        });
      }
      this.BindGrid();
    });
  }

  prepareReversalObject = (data, order_id, customer_id) => {
    let parsedJson;
    if (data && data.data) {
      parsedJson = JSON.parse(data.data);
    }
    const paymentObject = {
      customer_id: customer_id,
      order_id: order_id,
      is_duplicate: false,
      payment_date: parsedJson && parsedJson.created_at,
      host_response_code: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.host_code,
      result: 0,
      result_message: parsedJson && parsedJson.gateway_result_text,
      approved_amt: parsedJson && parsedJson.amount,
      batch_no: 0,
      batch_amt: 0,
      approved_code: '',
      account_no: '',
      avs_response_code: '',
      card_holder_name: '',
      card_type: parsedJson && parsedJson.card_type + '-' + parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data.card_type,
      card_brand: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data.card_brand,
      card_brand_short: '',
      language: '',
      alias: '',
      entry_type: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.entry_mode,
      receipt_text: "",
      exp_month: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.card_data && parsedJson.gateway_response.card_details.card_data.expiration_date && parsedJson.gateway_response.card_details.card_data.expiration_date.substr(0, 2),
      exp_year: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.card_data && parsedJson.gateway_response.card_details.card_data.expiration_date && parsedJson.gateway_response.card_details.card_data.expiration_date.substr(2, 2),
      trans_id: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.original_transaction && parsedJson.gateway_response.original_transaction.transaction_id,
      is_paid: parsedJson && parsedJson.transaction_status === "approved" ? true : false,
      host_response_description: '',
      trans_status: parsedJson && parsedJson.transaction_status,
      cardsecurity_response: '',
      processor_response: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.processor,
      masked_card_number: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.card_data && parsedJson.gateway_response.card_details.card_data.card_number,
      currency_code: parsedJson && parsedJson.card_type + '-' + parsedJson && parsedJson.gateway_response && parsedJson.gateway_response && parsedJson.gateway_response.card_details && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data && parsedJson.gateway_response.card_details.bin_data.issuing_country_code_a2,
      reference_id: parsedJson && parsedJson.gateway_reference_number,
      payment_type: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.payment_type,
      receipt: JSON.stringify(parsedJson),
      links: '',
      sales_id: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.original_transaction && parsedJson.gateway_response.original_transaction.transaction_id,
      card_token: parsedJson && parsedJson.gateway_response && parsedJson.gateway_response.token,
      ispaidfromgp: false,
      remote_id: parsedJson && parsedJson.remote_id,
      type: "REFUND",
      selected_payment_gateway: PaymentGatewaysEnum.AXIAMED,
      hash: ""
    };
    return paymentObject;
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, SelectedPaymentGateway, isHidden, isButtonDisabled, selectedObject, locale, queryId, groups } = this.state;
    return (
      <div id="react-no-print" className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle id="alert-dialog-title">{`${this.state && this.state.selectedObject && this.state.selectedObject.username}'s ${t("Report.iPay.Popup.PaymentDetail")}`}</DialogTitle>
            <DialogContent>
              <Table aria-labelledby="tableTitle">
                {
                  this.returnReceiptDetails(this.state.selectedObject, classes)
                }
              </Table>
            </DialogContent>
            <DialogActions id="react-no-print">
              {SelectedPaymentGateway === PaymentGatewaysEnum.AXIAMED ? (
                <div>
                  {((selectedObject && selectedObject.type === 'refund') || (selectedObject && selectedObject.type === 'REFUND')) ? (
                    ("")
                  ) : <Button onClick={() => { this.handleConfirmRefundOpenOrClose() }} color="primary" className={classes.primaryButton}>
                    {t("Report.iPay.Popup.RefundButton")}
                  </Button>
                  }
                </div>
              ) : ("")}
              &nbsp;&nbsp;&nbsp;<Button onClick={() => { this.PrintDetails() }} color="primary" className={classes.primaryButton}>
                {t("Report.iPay.Popup.PrintButton")}
              </Button>
              <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.iPay.Popup.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>

          <Box component="div">
            <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
              <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel sx={{ ml: '-4%' }} htmlFor="select-multiple-chip-store">{t("Report.iPay.Store")}</InputLabel>
                  <Select
                    multiple
                    value={this.state.chipstores}
                    onChange={this.handleStoreChange}
                    input={<Input id="select-multiple-chip-store" />}
                    renderValue={selected => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(value => (
                          <Chip key={value.name} label={value.name} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {this.state.accountValues !== undefined && this.state.accountValues.map(item => (
                      <MenuItem key={item.id} value={item}>
                        <Checkbox checked={this.state.nstores.map(x => x.id).indexOf(item.id) > -1} />
                        <ListItemText primary={item.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3} md={3}>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel sx={{ ml: '-4%' }} htmlFor="select-multiple-chip">{t("Report.iPay.Box")}</InputLabel>
                  <Select
                    multiple
                    value={this.state.chipboxes}
                    onChange={this.handleBoxChange}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={selected => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(value => (
                          <Chip key={value.id} label={value.name} className={classes.chip} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {this.state.boxvalues !== undefined && this.state.boxvalues.map(item => (
                      <MenuItem key={item.id} value={item}>
                        <Checkbox checked={this.state.nboxes.map(x => x.id).indexOf(item.id) > -1} />
                        <ListItemText primary={item.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3} md={3}>
                <FormControl sx={{ width: '100%' }}>
                  <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                    <DesktopDatePicker
                      disableFuture
                      keyboard
                      value={this.state.fromdate}
                      renderInput={(params) =>
                        <TextField
                          {...params}
                          label={t("Report.iPay.FromDate")}
                          variant="standard"
                          allowKeyboardControl={true}
                          onBlur={this.handleBlurfrom}
                        />
                      }
                      onChange={this.onFromDateSelect}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={3} md={3}>
                <FormControl sx={{ width: '100%' }}>
                  <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                    <DesktopDatePicker
                      disableFuture
                      keyboard
                      value={this.state.todate}
                      renderInput={(params) =>
                        <TextField
                          {...params}
                          label={t("Report.iPay.ToDate")}
                          variant="standard"
                          allowKeyboardControl={true}
                          onBlur={this.handleBlurtodate}
                        />
                      }
                      onChange={this.onToDateSelect}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
              <Grid item xs={3} md={3}>
                <FormControl fullWidth>
                  <TextField
                    id="idsearchtxt"
                    defaultValue=""
                    value={this.state.searchtxt}
                    label={t("Report.iPay.Search")}
                    onChange={this.onSearchChange}
                    variant="standard"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} md={3} style={{ paddingLeft: '32px' }}>
                <FormControl
                  variant='standard'
                  sx={{ m: '16px 0', minWidth: 347 }}
                >
                  <InputLabel id='preferred-group-label'>
                    {t('Group.User.GroupControlTitle')}
                  </InputLabel>
                  <Select
                    labelId='preferred-group-label'
                    id='preferred-group-select-standard'
                    value={queryId}
                    onChange={this.handleInputChange}
                    variant='standard'
                    label={t('Group.User.GroupControlTitle')}
                  >
                    {groups.length > 0 &&
                      groups.map((type, index) => (
                        <MenuItem
                          key={index}
                          value={type.id}
                          className={classes.locationType}
                        >
                          {type.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3} md={3}>
                <FormControl fullWidth>
                </FormControl>
              </Grid>
              <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
                <Tooltip key="single-edit" title={t("Report.iPay.ExportCSV")}>
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label="ExportCSV"
                    onClick={() => { this.exportCSV() }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
        </div>
        <Divider style={{ marginTop: '10px', height: '5px' }} />

        <div className={classes.tableWrapper}>
          <TableContainer>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={TransactionFilterObj.sortOrder}
                orderBy={TransactionFilterObj.sortColumn}
                sortId={this.state.sortId}
                onRequestSort={this.handleRequestSort}
              />
              <TableBody>
                {!data ?
                  (<TableRow>
                    <TableCell colSpan={16} style={{ textAlign: "center", padding: '10px 0px' }}>
                      {this.state.isDataEmpty && t("Report.iPay.NoDataFound")}
                    </TableCell>
                  </TableRow>) :
                  data.length && data.length > 0 &&
                  stableSort(data, getSorting(TransactionFilterObj.sortOrder, TransactionFilterObj.sortColumn))
                    .map(n => {
                      return (
                        <TableRow>
                          <TableCell className={classes.padding10px}>{n.firstname}</TableCell>
                          <TableCell className={classes.padding10px}>{n.lastname}</TableCell>
                          <TableCell className={classes.padding10px}>{n.store}</TableCell>
                          <TableCell className={classes.padding10px}>{n.box}</TableCell>
                          <TableCell className={classes.padding10px}>{n.pucode}</TableCell>
                          <TableCell className={classes.padding10px}><a href='' title="Print Receipt" style={{ color: '#385cad', fontWeight: 500, textDecoration: 'none ', fontSize: '1rem' }} onClick={(event) => this.handlePUcodeClick(event, (n.transaction_id || n.trans_id))}>{n.transaction_id || n.trans_id}</a></TableCell>
                          <TableCell className={classes.padding10px}>{n.trans_status || n.host_response_description}</TableCell>
                          <TableCell className={classes.padding10px}>{n.masked_card_number || n.account_no}</TableCell>
                          <TableCell className={classes.padding10px}>{n.card_type}</TableCell>
                          <TableCell className={classes.padding10px}>{n.card_brand}</TableCell>
                          <TableCell className={classes.padding10px}>{n.entry_type}</TableCell>
                          <TableCell className={classes.padding10px}>{n.reference_id}</TableCell>
                          <TableCell className={classes.padding10px}>{n.payment_date ? this.convertToTimeZone(n && n.payment_date) : ''}</TableCell>
                          <TableCell className={classes.padding10px}>{(n && n.selected_payment_gateway === PaymentGatewaysEnum.AXIAMED && n.type === "hpp") ? "" : (n.payment_type || n.card_type)}</TableCell>
                          <TableCell className={classes.padding10px}>{n.currency_code}</TableCell>
                          <TableCell className={classes.padding10px}>{n.approved_amt ? '$' + parseFloat(n.approved_amt).toFixed(2) : '$0.00'}</TableCell>
                          <TableCell className={classes.padding10px}>{n && n.type && n.type.toUpperCase()}</TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={TransactionFilterObj.pageSize}
            page={TransactionFilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
        <Dialog
          open={this.state.confirmationForRefund || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth={'sm'}
        >
          <DialogTitle id="alert-dialog-title">Refund Confirmation</DialogTitle>
          <DialogContent>
            <Table aria-labelledby="tableTitle">
              {/*  */}
              {this.state && this.state.reversalConfirmationMessage}
            </Table>
          </DialogContent>
          <DialogActions id="react-no-print">
            {isHidden ? (
              <div>
                <Button disabled={isButtonDisabled} onClick={(e) => { this.handleConfirmRefundOpenOrClose(e) }} color="primary" className={classes.primaryButton}>
                  Ok
                </Button>
              </div>
            ) : (
              <div>
                <Button disabled={isButtonDisabled} onClick={() => { this.initRefund() }} color="primary" className={classes.primaryButton}>
                  Yes
                </Button>&nbsp;&nbsp;
                <Button disabled={isButtonDisabled} onClick={(e) => { this.handleConfirmRefundOpenOrClose(e) }} color="primary" className={classes.primaryButton}>
                  No
                </Button>
              </div>
            )}

          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/ipay_transaction/index.js